'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssComponent = require('react-css-component');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var css = '\n.page-header {\n  top: 91px;\n  position: fixed;\n  background-color: #00b9f7;\n  height: 61px;\n  max-height: 61px;\n  line-height: 61px;\n  color: white;\n  width: 100%;\n  margin: 0;\n  border-bottom: 0;\n  z-index: 10;\n}\n\n.menu {\n  padding: 0 30px;\n  display: inline-block;\n}\n\n.page-title {\n  display: inline-block;\n}\n\n.page-header h1 {\n  line-height: 61px;\n  margin-top: 0;\n  color: white;\n}\n\n.view-header-primary-sport.NFL {\n    color: #37b346;\n}\n.view-header-primary-sport.NBA {\n    color: #c08320;\n}\n.view-header-primary-sport.MLB {\n    color: #f01621;\n}\n.view-header-primary-sport.NHL {\n    color: #12c6c8;\n}\n.view-header-primary-sport.PGA {\n    color: #3c9369;\n}\n.view-header-primary-title {\n    background-color: #00b9f7;\n    color: #fff;\n\n}\n.view-header-primary-sport {\n    background-color: #f6f6f6;\n    min-height: 63px;\n}\n.view-header-primary-sport, .view-header-primary-title {\n    display: inline-block;\n    padding: 0 20px;\n    font-size: 21px;\n    border-right: 1px solid hsla(0,0%,100%,.5);\n    letter-spacing: 0.1px;\n    margin: 0;\n}\n';

// header

var PageHeader = function PageHeader(props) {
    var handleSourceChange = props.handleSourceChange;
    var sourceId = props.sourceId;
    if (sourceId === undefined) {
        sourceId = 4;
    }
    var spanClass = 'view-header-primary-sport ' + props.sport.toUpperCase();
    var display = _react2.default.createElement(
        'div',
        { className: 'page-header' },
        _react2.default.createElement(_reactCssComponent.ClientStyle, { css: css }),
        _react2.default.createElement(
            'div',
            { className: spanClass },
            props.sport.toUpperCase()
        ),
        _react2.default.createElement(
            'a',
            { href: props.returnURL },
            _react2.default.createElement(
                'h1',
                { className: 'view-header-primary-title' },
                props.title
            )
        ),
        _react2.default.createElement(
            'nav',
            { className: 'page-header-nav center' },
            _react2.default.createElement(
                'ul',
                { className: props.displaySources ? 'tabs' : 'hide' },
                props.sources.map(function (source) {
                    if (source.id === 3 || source.id === 4) {
                        return _react2.default.createElement(
                            'li',
                            { key: source.id },
                            _react2.default.createElement(
                                'a',
                                {
                                    onClick: function onClick() {
                                        return handleSourceChange(source.id);
                                    },
                                    className: +sourceId === source.id ? 'active' : ''
                                },
                                source.display_name
                            )
                        );
                    }
                    return null;
                })
            )
        )
    );

    return display;
};

exports.default = PageHeader;


//////////////////
// WEBPACK FOOTER
// ../component-library/build/navigation/PageHeader.js
// module id = 793
// module chunks = 0